// types
import { USER_UPDATE_ROUTES, USER_UPDATE_SINISTERS } from '@/store/types'

export default {
  [USER_UPDATE_ROUTES] ({ state, commit }, payload) {
    commit(USER_UPDATE_ROUTES, payload)
  },
  [USER_UPDATE_SINISTERS] ({ state, commit }, payload) {
    commit(USER_UPDATE_SINISTERS, payload)
  }
}
